import type { FC, MouseEvent } from "react";

import { classes, Icon, Text } from "@alpacahq/ui/old";

type TierBoxProps = {
  title: string;
  subTitle: string;
  features: string[];
  isSelected: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  isDisabled?: boolean;
};

export const TierBox: FC<TierBoxProps> = ({
  title,
  subTitle,
  features,
  isSelected,
  onClick,
  isDisabled,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={classes(
      "flex w-full max-w-72 flex-col rounded border-2 px-4 pt-4 pb-4",
      isDisabled
        ? "cursor-not-allowed opacity-[0.45]"
        : isSelected
          ? "border-yellow-400 bg-[#fefce880]"
          : "border-gray-200",
    )}
    disabled={isDisabled}
  >
    <div className="mb-2 space-y-2 text-left">
      <h3 className="text-lg">{title}</h3>
      <Text>{subTitle}</Text>
    </div>

    <ul>
      {features.map((text) => (
        <li key={text} className="flex pb-3">
          <Icon name="Check" className="text-gray-600" />
          <Text className="pl-4 text-gray-600">{text}</Text>
        </li>
      ))}
    </ul>
  </button>
);
